import React, { useEffect, useState } from 'react';
import {
    Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, InputAdornment,
    TextField, Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
// import { LimitValue } from '../../../utils/LimitValue';
// import { FormatNumberToBr } from '../../../utils/FormatNumberToBr';

const corPrimaria = "#0b243d";

// "1.234,56" -> 1234.56 (mesma conversão usada no envio)
const paraNumero = (valor) => Number(String(valor || "").replaceAll(".", "").replaceAll(",", "."));

// Prévia do desconto com a mesma fórmula do handleSubmit
const percentualDesconto = (antigo, novo) => {
    const vlAntigo = paraNumero(antigo);
    const vlNovo = paraNumero(novo);
    if (!vlAntigo || Number.isNaN(vlAntigo) || Number.isNaN(vlNovo)) return null;
    return ((vlAntigo - vlNovo) / vlAntigo) * 100;
};

function Secao({ titulo, extra, children }) {
    return (
        <Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1.5 }}>
                <Typography variant="overline" sx={{ color: "text.secondary", fontWeight: 600, lineHeight: 1.5 }}>{titulo}</Typography>
                {extra}
            </Box>
            {children}
        </Box>
    );
}

function ChipDesconto({ antigo, novo }) {
    const desconto = percentualDesconto(antigo, novo);
    if (desconto === null) return null;
    return (
        <Chip
            size="small"
            color={desconto > 0 ? "success" : desconto < 0 ? "error" : "default"}
            variant="outlined"
            label={desconto > 0 ? `${desconto.toFixed(0)}% de desconto` : desconto < 0 ? "Valor novo maior que o antigo" : "Sem desconto"}
            sx={{ height: 22, fontSize: 11 }}
        />
    );
}

const linha = { display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" } };
const adornoReais = { input: { startAdornment: <InputAdornment position="start">R$</InputAdornment> } };

export default function EditarPlano(props) {
    const token = localStorage.getItem('token');

    const [nomePlano, setNomePlano] = useState('');
    const [valorAntigo, setValorAntigo] = useState('');
    const [valorNovo, setValorNovo] = useState('');
    const [descricao, setDescricao] = useState('');
    const [valorAntigoAnual, setValorAntigoAnual] = useState('');
    const [valorNovoAnual, setValorNovoAnual] = useState('');
    const [qtdNfseMensalUsuario, setQtdNfseMensalUsuario] = useState('');
    const [qtdNfseMensalClarea, setQtdNfseMensalClarea] = useState('');
    const [salvando, setSalvando] = useState(false);

    useEffect(() => {
        const getPlanoById = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/getPlanoById/${props.idPlano}`, {
                headers: {
                    Authorization: token
                }
            });

            console.log(response)
            setNomePlano(response?.data?.plano?.nome);
            setValorAntigo(response?.data?.plano?.valorAntigoMensal.replace(".", ","));
            setValorNovo(response?.data?.plano?.valorNovoMensal.replace(".", ","));
            setDescricao(response?.data?.plano?.descricao);
            setValorAntigoAnual(response?.data?.plano?.valorAntigoAnual.replace(".", ","));
            setValorNovoAnual(response?.data?.plano?.valorNovoAnual.replace(".", ","));
            setQtdNfseMensalUsuario(response?.data?.plano?.qtdNfseMensalUsuario);
            setQtdNfseMensalClarea(response?.data?.plano?.qtdNfseMensalClarea);
        }
        // Antes de escolher um plano não há o que buscar
        if (props.idPlano) getPlanoById();
    }, [props.idPlano, token]);


    const handleClose = () => {
        props.setEditarPlano(false);
    };

    const handleSubmit = async (event) => {
        let vlAntigo = Number(valorAntigo.replaceAll(".", "").replaceAll(",", "."));
        let vlNovo = Number(valorNovo.replaceAll(".", "").replaceAll(",", "."));
        let vlAntigoAnual = Number(valorAntigoAnual.replaceAll(".", "").replaceAll(",", "."));
        let vlNovoAnual = Number(valorNovoAnual.replaceAll(".", "").replaceAll(",", "."));

        let x = vlAntigo - vlNovo;
        let percentual = (x / vlAntigo) * 100;

        let y = vlAntigoAnual - vlNovoAnual;
        let percentualAnual = (y / vlAntigoAnual) * 100;

        try {
            setSalvando(true);
            await axios.put(`${process.env.REACT_APP_API_URL}/atualizarPlano/${props.idPlano}`, {
                nomePlano,
                vlAntigo,
                vlNovo,
                vlAntigoAnual,
                vlNovoAnual,
                percentualAnual,
                percentual,
                descricao,
                qtdNfseMensalUsuario,
                qtdNfseMensalClarea
            }, {
                headers: {
                    Authorization: token
                }
            });
            handleClose();
        } catch (error) {
            console.error("Erro ao atualizar desconto:", error);
        } finally {
            setSalvando(false);
        }
    };

    return (
        <React.Fragment>
            <Dialog open={props.editarPlano} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 2, pb: 1 }}>
                    <Box>
                        <Typography sx={{ fontSize: 18, fontWeight: 600 }}>Editar plano</Typography>
                        <Typography variant="body2" color="text.secondary">
                            O desconto é calculado automaticamente a partir do valor antigo e do novo.
                        </Typography>
                    </Box>
                    <IconButton size="small" aria-label="Fechar" onClick={handleClose}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                    <Secao titulo="Identificação">
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                            <TextField
                                autoFocus
                                required
                                label="Nome do plano"
                                placeholder='Insira o nome do plano'
                                type="text"
                                fullWidth
                                value={nomePlano || ''}
                                onChange={(e) => setNomePlano(e.target.value)}
                                variant="outlined"
                                size='small'
                            />
                            <TextField
                                required
                                label="Descrição"
                                placeholder='Descreva o que o plano oferece'
                                type="text"
                                fullWidth
                                multiline
                                minRows={2}
                                value={descricao || ''}
                                onChange={(e) => setDescricao(e.target.value)}
                                variant="outlined"
                                size='small'
                            />
                        </Box>
                    </Secao>

                    <Divider />

                    <Secao titulo="Valores mensais" extra={<ChipDesconto antigo={valorAntigo} novo={valorNovo} />}>
                        <Box sx={linha}>
                            <TextField
                                required
                                label="Valor antigo"
                                placeholder='0,00'
                                type="text"
                                fullWidth
                                value={valorAntigo || ''}
                                onChange={(e) => setValorAntigo(e.target.value)}
                                variant="outlined"
                                size='small'
                                slotProps={adornoReais}
                            />
                            <TextField
                                required
                                label="Valor novo"
                                placeholder='0,00'
                                type="text"
                                fullWidth
                                value={valorNovo || ''}
                                onChange={(e) => setValorNovo(e.target.value)}
                                variant="outlined"
                                size='small'
                                slotProps={adornoReais}
                            />
                        </Box>
                    </Secao>

                    <Secao titulo="Valores anuais" extra={<ChipDesconto antigo={valorAntigoAnual} novo={valorNovoAnual} />}>
                        <Box sx={linha}>
                            <TextField
                                required
                                label="Valor antigo"
                                placeholder='0,00'
                                type="text"
                                fullWidth
                                value={valorAntigoAnual || ''}
                                onChange={(e) => setValorAntigoAnual(e.target.value)}
                                variant="outlined"
                                size='small'
                                slotProps={adornoReais}
                            />
                            <TextField
                                required
                                label="Valor novo"
                                placeholder='0,00'
                                type="text"
                                fullWidth
                                value={valorNovoAnual || ''}
                                onChange={(e) => setValorNovoAnual(e.target.value)}
                                variant="outlined"
                                size='small'
                                slotProps={adornoReais}
                            />
                        </Box>
                    </Secao>

                    <Divider />

                    <Secao titulo="Limite de NFS-e por mês">
                        <Box sx={linha}>
                            <TextField
                                required
                                label="Emitidas pelo usuário"
                                placeholder='Insira a quantidade'
                                type="text"
                                fullWidth
                                value={qtdNfseMensalUsuario || ''}
                                onChange={(e) => setQtdNfseMensalUsuario(e.target.value)}
                                variant="outlined"
                                size='small'
                            />
                            <TextField
                                required
                                label="Emitidas pela Clarea"
                                placeholder='Insira a quantidade'
                                type="text"
                                fullWidth
                                value={qtdNfseMensalClarea || ''}
                                onChange={(e) => setQtdNfseMensalClarea(e.target.value)}
                                variant="outlined"
                                size='small'
                            />
                        </Box>
                    </Secao>
                </DialogContent>
                <DialogActions sx={{ px: 3, py: 1.5 }}>
                    <Button onClick={handleClose} size='small' sx={{ textTransform: "none" }} disabled={salvando}>Cancelar</Button>
                    <Button
                        onClick={handleSubmit}
                        variant='contained'
                        size='small'
                        loading={salvando}
                        sx={{ backgroundColor: corPrimaria, textTransform: "none", "&:hover": { backgroundColor: "#153d66" } }}
                    >
                        Salvar alterações
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
